import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=34e9c926&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./scss/order.scss?vue&type=style&index=0&id=34e9c926&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e9c926",
  null
  
)

export default component.exports